export default "__VITE_ASSET__BWj7vl8r__"